<mat-drawer-container>
    <mat-drawer-content>
        <div class="list-container main-container" fxFlex fxLayout="column">
            <div class="page-header" fxFlex fxLayoutAlign="space-between center">
                <div class="d-flex-center">
                    <mat-form-field class="form-element filterItem">
                        <mat-label>by station</mat-label>
                        <input matInput inputrestriction="basic1" type="text" (keyup)="applyFilter()" class="form-control" [(ngModel)]="filters['stationId']" autocomplete="off" />
                        <a matSuffix aria-label="Clear" (click)="clearFilter('stationId')">
                            <mat-icon>close</mat-icon>
                        </a>
                    </mat-form-field>
                    <mat-form-field class="form-element filterItem">
                        <mat-label>by tag</mat-label>
                        <input matInput inputrestriction="basic1" type="text" (keyup)="applyFilter()" class="form-control" [(ngModel)]="filters['tag']" autocomplete="off" />
                        <a matSuffix aria-label="Clear" (click)="clearFilter('tag')">
                            <mat-icon>close</mat-icon>
                        </a>
                    </mat-form-field>
                    <mat-form-field class="form-element filterItem">
                        <mat-label>by category</mat-label>
                        <input matInput inputrestriction="basic1" type="text" (keyup)="applyFilter()" class="form-control" [(ngModel)]="filters['category']" autocomplete="off" />
                        <a matSuffix aria-label="Clear" (click)="clearFilter('category')">
                            <mat-icon>close</mat-icon>
                        </a>
                    </mat-form-field>
                    <mat-form-field class="form-element filterItem">
                        <mat-label>by content</mat-label>
                        <input matInput inputrestriction="basic1" type="text" (keyup)="applyFilter()" class="form-control" [(ngModel)]="filters['content']" autocomplete="off" />
                        <a matSuffix aria-label="Clear" (click)="clearFilter('content')">
                            <mat-icon>close</mat-icon>
                        </a>
                    </mat-form-field>
                    <mat-form-field class="form-element filterItem">
                        <mat-label>by label</mat-label>
                        <input matInput inputrestriction="basic1" type="text" (keyup)="applyFilter()" class="form-control" [(ngModel)]="filters['label']" autocomplete="off" />
                        <a matSuffix aria-label="Clear" (click)="clearFilter('label')">
                            <mat-icon>close</mat-icon>
                        </a>
                    </mat-form-field>
                    <button mat-icon-button (click)="exportToCSV()" matTooltip="{{ 'general.export' | transloco }} [csv]" style="margin-left: 10px">
                        <mat-icon>cloud_download</mat-icon>
                    </button>
                    <button mat-icon-button (click)="refresh()" matTooltip="{{ 'general.refresh' | transloco }}">
                        <mat-icon>refresh</mat-icon>
                    </button>
                    <button mat-icon-button (click)="clearStatistic()" matTooltip="{{ 'general.clear' | transloco }}" [disabled]="!dataSource?.data?.length">
                        <mat-icon>delete</mat-icon>
                    </button>
                    <app-video-link style="display: inline-block;" videoLink="/help/sign_pop"></app-video-link>

                </div>
            </div>

            <div class="tableWrapper">
                <table mat-table [hidden]="!dataSource" [dataSource]="dataSource" matSort class="mat-elevation-z8">
                    <ng-container matColumnDef="stationId">
                        <th mat-header-cell mat-sort-header *matHeaderCellDef>{{ "general.station" | transloco }} ID</th>
                        <td mat-cell *matCellDef="let element">{{ element.stationId }}</td>
                    </ng-container>
                    <ng-container matColumnDef="station">
                        <th mat-header-cell mat-sort-header *matHeaderCellDef>{{ "general.station" | transloco }}</th>
                        <td mat-cell *matCellDef="let element">{{ element.station }}</td>
                    </ng-container>
                    <ng-container matColumnDef="date">
                        <th mat-header-cell mat-sort-header *matHeaderCellDef>{{ "general.date" | transloco }}</th>
                        <td mat-cell *matCellDef="let element">{{ element.date }}</td>
                    </ng-container>
                    <ng-container matColumnDef="hour">
                        <th mat-header-cell mat-sort-header *matHeaderCellDef>{{ "general.hour" | transloco }}</th>
                        <td mat-cell *matCellDef="let element">{{ element.hour }}</td>
                    </ng-container>
                    <ng-container matColumnDef="tag">
                        <th mat-header-cell mat-sort-header *matHeaderCellDef>{{ "general.tag" | transloco }}</th>
                        <td mat-cell *matCellDef="let element">{{ element.tag }}</td>
                    </ng-container>
                    <ng-container matColumnDef="category">
                        <th mat-header-cell mat-sort-header *matHeaderCellDef>{{ "general.category" | transloco }}</th>
                        <td mat-cell *matCellDef="let element">{{ element.category }}</td>
                    </ng-container>
                    <ng-container matColumnDef="content">
                        <th mat-header-cell mat-sort-header *matHeaderCellDef>{{ "general.content" | transloco }}</th>
                        <td mat-cell *matCellDef="let element">{{ element.content }}</td>
                    </ng-container>
                    <ng-container matColumnDef="label">
                        <th mat-header-cell mat-sort-header *matHeaderCellDef>{{ "general.label" | transloco }}</th>
                        <td mat-cell *matCellDef="let element">{{ element.label }}</td>
                    </ng-container>
                    <ng-container matColumnDef="count">
                        <th mat-header-cell mat-sort-header *matHeaderCellDef>{{ "general.count" | transloco }}</th>
                        <td mat-cell *matCellDef="let element">{{ element.count | number : "1.0-2" }}</td>
                    </ng-container>
                    <ng-container matColumnDef="duration">
                        <th mat-header-cell mat-sort-header *matHeaderCellDef>{{ "general.duration" | transloco }}</th>
                        <td mat-cell *matCellDef="let element">{{ element.duration | number : "1.2-2" }}</td>
                    </ng-container>
                    <ng-container matColumnDef="select">
                        <th mat-header-cell *matHeaderCellDef>
                            @if (chartEnabled) {
                                <span>chart</span>
                            }
                            <!-- <mat-checkbox *ngIf="!chartEnabled" (change)="$event ? masterToggle() : null"
                            [checked]="selection.hasValue() && isAllSelected()"
                            [indeterminate]="selection.hasValue() && !isAllSelected()">
                            </mat-checkbox> -->
                        </th>
                        <td mat-cell *matCellDef="let row">
                            @if (chartEnabled) {
                                <div class="d-flex-center">
                                    <mat-checkbox [checked]="selection.isSelected(row.uuid)" (change)="checkChartRow(row)"></mat-checkbox>
                                    @if (selection.isSelected(row.uuid)) {
                                        <input type="color" class="chart-color-cell" [value]="colors[row.uuid] || whiteColor" (change)="colorPickerChange($event, row)" />
                                    }
                                    <!-- <input class="chart-color-cell"
                                    [style.color]="row.color"
                                    [cpPosition]="'bottom'"
                                    [readonly]="true"
                                    [cpPositionOffset]="'50%'"
                                    [cpOutputFormat]="'hex'"
                                    [cpPositionRelativeToArrow]="true"
                                    [(colorPicker)]="row.color"
                                    (colorPickerChange)="colorPickerChange($event, row)"
                                    /> -->
                                                    <!-- <input #ignoredInput type="text" spellcheck="false" autocomplete="off" class="chart-color-cell"
                                    [style.background]="row.color"
                                    [style.color]="row.color"
                                    [cpPosition]="'bottom'"
                                    [readonly]="true"
                                    [cpOutputFormat]="'hex'"
                                    [cpIgnoredElements]="[ignoredInput]"
                                    [(cpToggle)]="colorToggle"
                                    [(colorPicker)]="row.color"
                                    (click)="colorToggle=!colorToggle"
                                    (colorPickerChange)="colorPickerChange($event, row)"/> -->
                                </div>
                            }
                        </td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
                </table>

                @if (!dataSource) {
                    <div style="overflow: hidden; height: 150px">
                        <app-loading [size]="'50px'" [style]="{ 'margin-top': '50px' }"></app-loading>
                        <br />
                        <div fxLayout="row" fxLayoutAlign="center center">
                            <mat-icon>hourglass_empty</mat-icon>
                            {{ "placeholder.makeTakeMinute" | transloco }} ...
                        </div>
                    </div>
                }
                @if (dataSource && loading) {
                    <div class="loading">
                        <app-loading [type]="10" [size]="'60px'"></app-loading>
                    </div>
                }
            </div>
            <mat-paginator customPageSize [pageSize]="pageSize" [pageSizeOptions]="pageSizeOptions" [showFirstLastButtons]="true"></mat-paginator>

            @if (enableChart && chartData && isShowChart && selection.hasValue()) {
                <div class="chart-container">
                    <app-station-statistic-chart [chartData]="chartData" [chartType]="chartType"></app-station-statistic-chart>
                </div>
            }
        </div>
    </mat-drawer-content>

    <mat-drawer [opened]="sidenavOpened" [mode]="sidenavMode" position="end" #sidenav>
        <div class="props-container">
            <mat-accordion>
                <mat-expansion-panel expanded>
                    <mat-expansion-panel-header>
                        <mat-panel-title>
                            <fa-icon size="lg" [icon]="faFilter"></fa-icon>
                            <span class="accordionIcons">aggregation & filter</span>
                        </mat-panel-title>
                        <mat-panel-description></mat-panel-description>
                    </mat-expansion-panel-header>
                    <div class="filter-wrapper">
                        <label id="filter-radio-group-label">filter by:</label>
                        <mat-radio-group aria-labelledby="filter-radio-group-label" class="filter-radio-group" [(ngModel)]="dateFilter" (change)="filterByDate()">
                            <!-- <mat-radio-button class="filter-radio-button" value="">all</mat-radio-button> -->
                            <mat-radio-button class="filter-radio-button" value="today">today</mat-radio-button>
                            <mat-radio-button class="filter-radio-button" value="yesterday">yesterday</mat-radio-button>
                            <mat-radio-button class="filter-radio-button" value="thisweek">this week</mat-radio-button>
                            <mat-radio-button class="filter-radio-button" value="lastweek">last week</mat-radio-button>
                            <mat-radio-button class="filter-radio-button" value="thismonth">this month</mat-radio-button>
                            <mat-radio-button class="filter-radio-button" value="month1">1 month ago</mat-radio-button>
                            <mat-radio-button class="filter-radio-button" value="month2">2 months ago</mat-radio-button>
                            <!-- <mat-radio-button class="filter-radio-button" value="custom">custom</mat-radio-button> -->
                        </mat-radio-group>

                        @if (dateFilter === 'custom') {
                            <div>
                                <mat-form-field class="custom-date-range">
                                    <mat-label>enter filter date range</mat-label>
                                    <mat-date-range-input [formGroup]="range" [rangePicker]="rangePicker">
                                        <input matStartDate formControlName="start" placeholder="Start date" />
                                        <input matEndDate formControlName="end" placeholder="End date" />
                                    </mat-date-range-input>
                                    <mat-hint>MM/DD/YYYY - MM/DD/YYYY</mat-hint>
                                    <mat-datepicker-toggle matIconSuffix [for]="rangePicker"></mat-datepicker-toggle>
                                    <mat-date-range-picker #rangePicker>
                                        <mat-date-range-picker-actions>
                                            <button mat-button matDateRangePickerCancel>Cancel</button>
                                            <button mat-raised-button color="primary" matDateRangePickerApply (click)="filterByDateRange()">Apply</button>
                                        </mat-date-range-picker-actions>
                                    </mat-date-range-picker>
                                </mat-form-field>
                            </div>
                        }
                    </div>
                    <div class="aggregation-wrapper">
                        <label>aggregate by:</label>
                        <div fxFlex fxLayout="column" class="aggregation-group">
                            @for (opt of aggregateOptions; track opt) {
                                <mat-checkbox
                                    [checked]="aggregateSelection.includes(opt)"
                                    (change)="aggregateBy($event.checked, opt)"
                                    [disabled]="loading || (chartEnabled && chartType !== 'pie' && aggregateDatetimeOptions.includes(opt))"
                                >
                                    {{ aggragateFieldMapping[opt] }}
                                </mat-checkbox>
                            }
                        </div>
                    </div>
                </mat-expansion-panel>
                <mat-expansion-panel>
                    <mat-expansion-panel-header>
                        <mat-panel-title>
                            <fa-icon size="lg" [icon]="faChartSimple"></fa-icon>
                            <span class="accordionIcons">chart</span>
                        </mat-panel-title>
                        <mat-panel-description></mat-panel-description>
                    </mat-expansion-panel-header>
                    <mat-checkbox [(ngModel)]="chartEnabled" (click)="enableChart()">enable chart</mat-checkbox>
                    <mat-checkbox [(ngModel)]="showSelectedOnly" (click)="changeShowSelectedOnly()" [disabled]="!selection.hasValue()">show selected only</mat-checkbox>

                    @if (chartEnabled) {
                        <div class="chart-options">
                            <label id="chart-radio-group-label">select chart type:</label>
                            <mat-radio-group aria-labelledby="chart-radio-group-label" class="chart-radio-group" [(ngModel)]="chartType" (change)="changeChartType()">
                                <mat-radio-button class="chart-radio-button" value="pie">pie - counts & duration</mat-radio-button>
                                <mat-radio-button class="chart-radio-button" value="dot-counts">dot - counts</mat-radio-button>
                                <mat-radio-button class="chart-radio-button" value="dot-duration">dot - duration</mat-radio-button>
                            </mat-radio-group>
                        </div>
                    }
                    <br />
                    <div fxFlex fxLayoutAlign="center center">
                        @if (chartEnabled && chartType) {
                            <button mat-raised-button type="button" class="chart-create-button" color="primary" (click)="drawChart()" [disabled]="!selection.hasValue()">
                                @if (chartType === 'pie') {
                                    <mat-icon>pie_chart</mat-icon>
                                } @else {
                                    <mat-icon>scatter_plot</mat-icon>
                                } view chart
                            </button>
                        }
                    </div>
                </mat-expansion-panel>
            </mat-accordion>
        </div>
    </mat-drawer>
</mat-drawer-container>
